import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navLinks = [{
    name: 'Services',
    href: '#'
  }, {
    name: 'About',
    href: '#'
  }, {
    name: 'Resources',
    href: '#'
  }, {
    name: 'For Providers',
    href: '#'
  }, {
    name: 'Client Portal',
    href: '#'
  }];
  return <nav className="sticky top-0 z-50 w-full border-b border-stone-100 bg-white/80 backdrop-blur-md" data-id="element-120">
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8" data-id="element-121">
        {/* Logo */}
        <div className="flex items-center gap-2" data-id="element-122">
          <div className="h-8 w-8 rounded-full flex items-center justify-center" style={{
          backgroundColor: '#074e3b'
        }} data-id="element-123">
            <span className="text-white font-serif font-bold" data-id="element-124">W</span>
          </div>
          <span className="text-xl font-serif font-bold text-stone-800 tracking-tight" data-id="element-125">
            Well Balanced Nutrition
          </span>
        </div>

        {/* Desktop Nav */}
        <div className="hidden md:flex md:items-center md:gap-8" data-id="element-126">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-stone-600 hover:text-stone-900 transition-colors" data-id="element-127">
              {link.name}
            </a>)}
          <Button size="sm" variant="secondary" data-id="element-128">
            Get Started
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden p-2 text-stone-600" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-129">
          {isOpen ? <X className="h-6 w-6" data-id="element-130" /> : <Menu className="h-6 w-6" data-id="element-131" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isOpen && <div className="md:hidden border-t border-stone-100 bg-white px-4 py-6 shadow-lg" data-id="element-132">
          <div className="flex flex-col space-y-4" data-id="element-133">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-stone-600 hover:text-stone-900" onClick={() => setIsOpen(false)} data-id="element-134">
                {link.name}
              </a>)}
            <Button className="w-full justify-center" variant="secondary" data-id="element-135">
              Get Started
            </Button>
          </div>
        </div>}
    </nav>;
}